export default new function hamburger($) {
  let $html;
  let $mobileNav;
  let $mobileNavToggle;
  let $mobileSubNavToggle;
  let $mobileSubNavToggleAnchors;
  let $mobileSubNavToggleSearch;

  this.init = () => {
    this.setVars();
    this.modifyDOM();
    this.addEvents();
  };

  this.setVars = () => {
    $html = $('html');
    $mobileNav = $('.mobile-navigation');
    $mobileNavToggle = $('.mobile-navigation-toggle');
    $mobileSubNavToggle = $mobileNav.find('> ul > .menu-item-has-children, > ul > .menu-item-has-children-items');
    $mobileSubNavToggleAnchors = $mobileSubNavToggle.find('a[href]');
    $mobileSubNavToggleSearch = $mobileSubNavToggle.find('form[role="search"]');
  };

  this.modifyDOM = () => {
  };

  this.addEvents = () => {
    $mobileNavToggle.on('click', this.eventHandlers.showMobileMenu);
    $mobileSubNavToggleAnchors.on('click', this.eventHandlers.fixAnchors);
    $mobileSubNavToggleSearch.on('click', this.eventHandlers.fixSearch);
    $mobileSubNavToggle.on('click', this.eventHandlers.showMobileSubMenu);
  };

  this.eventHandlers = {
    showMobileMenu() {
      if ($mobileNavToggle.hasClass('active')) {
        $mobileNavToggle.removeClass('active');
        $mobileNav.removeClass('mobile-navigation--collapsed');
        $html.removeClass('mobile-navigation-open');
      } else {
        $mobileNavToggle.addClass('active');
        $mobileNav.addClass('mobile-navigation--collapsed');
        $html.addClass('mobile-navigation-open');
      }
    },

    showMobileSubMenu(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $(e.target).toggleClass('collapsed').find('> ul').toggle();
    },

    fixAnchors(e) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = $(this).attr('href');
    },

    fixSearch(e) {
      // e.preventDefault();
      e.stopPropagation();
    }
  };

  this.helpers = {
  };

  return this.init;
}(jQuery);
